var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#222222",
    stroke: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.392 8.25C21.105 8.25 22.4993 9.63151 22.4993 11.3289L22.5 13.3368C22.5 13.484 22.4408 13.6267 22.3358 13.7307C22.23 13.8355 22.0875 13.8942 21.9375 13.8942C21.3218 13.8942 20.8207 14.3906 20.8207 15.0007C20.8207 15.6109 21.3218 16.1073 21.9375 16.1073C22.248 16.1073 22.5 16.357 22.5 16.6646V18.6719C22.5 20.3692 21.1065 21.75 19.3935 21.75H10.6073C8.89425 21.75 7.5 20.3692 7.5 18.6719V16.6646C7.5 16.357 7.752 16.1073 8.0625 16.1073C8.679 16.1073 9.18 15.6109 9.18 15.0007C9.18 14.4062 8.69925 13.9589 8.0625 13.9589C7.91325 13.9589 7.77075 13.9001 7.665 13.7954C7.55925 13.6906 7.5 13.5486 7.5 13.4015L7.5015 11.3289C7.5015 9.63151 8.895 8.25 10.608 8.25H19.392ZM15.0015 12.1151C14.7885 12.1151 14.598 12.2325 14.5027 12.4213L13.956 13.5189L12.7365 13.695C12.5257 13.7248 12.3532 13.8674 12.2865 14.0681C12.2205 14.2687 12.2737 14.4857 12.4267 14.6329L13.311 15.486L13.1025 16.6921C13.0665 16.9002 13.1512 17.1068 13.3237 17.2309C13.4212 17.3 13.5345 17.3357 13.6493 17.3357C13.737 17.3357 13.8255 17.3142 13.9065 17.2718L15 16.7025L16.0912 17.2703C16.2802 17.3706 16.5045 17.355 16.6762 17.2302C16.8495 17.1068 16.9343 16.9002 16.8983 16.6921L16.689 15.486L17.5732 14.6329C17.727 14.4857 17.7803 14.2687 17.7135 14.0681C17.6475 13.8674 17.475 13.7248 17.2665 13.6958L16.0447 13.5189L15.498 12.422C15.4042 12.2333 15.2137 12.1158 15.0015 12.1151Z",
    fill: "#666687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNft);
export default __webpack_public_path__ + "static/media/nft.c6bfe92ab8630d8e86e409c5d0b7ee6e.svg";
export { ForwardRef as ReactComponent };